import { RightOutlined } from '@ant-design/icons';
import BottomSheet from 'components/UI/Responsive/BottomSheet';
import { ReactNode } from 'react';

import * as S from './styles';

export interface SheetAction {
  key: string;
  label: string;
  hint: string;
  icon: ReactNode;
  tone?: 'success' | 'danger';
  disabled?: boolean;
  onSelect: () => void;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  actions: SheetAction[];
}

export default function ActionSheet({
  isOpen,
  onClose,
  title,
  description,
  actions,
}: Props) {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      summary={<S.Description>{description}</S.Description>}
      footer={
        <S.CancelButton type="button" onClick={onClose}>
          Cancelar
        </S.CancelButton>
      }
    >
      <S.Actions>
        {actions.map((action) => (
          <S.Action
            key={action.key}
            type="button"
            disabled={action.disabled}
            onClick={() => {
              onClose();
              action.onSelect();
            }}
          >
            <S.ActionIcon data-tone={action.tone} aria-hidden>
              {action.icon}
            </S.ActionIcon>
            <S.ActionText>
              <strong>{action.label}</strong>
              <S.ActionHint>{action.hint}</S.ActionHint>
            </S.ActionText>
            <RightOutlined aria-hidden />
          </S.Action>
        ))}
      </S.Actions>
    </BottomSheet>
  );
}
